import Service, { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

import { findAll } from '@ember-data/legacy-compat/builders';

export default class CodeRepoService extends Service {
  @service store;

  rejectCodes = this.store.peekAll('reject-code');
  repairCodes = this.store.peekAll('repair-code');
  faultCodes = this.store.peekAll('fault-code');
  scrapCodes = this.store.peekAll('scrap-code');

  filterCodesByOptions(type, codes, options) {
    const globalCodes = codes.filter(({ stations }) => isEmpty(stations));
    const stationCodes = options.station?.[`${type}Codes`] ?? [];


    if (options.isFromSync) {
      return globalCodes.filter(({ isFromSync }) => isFromSync);
    }

    return globalCodes.concat(stationCodes);
  }

  filteredCodes(type, options) {
    const codes = this[`${type}Codes`];

    return this.filterCodesByOptions(type, codes, options);
  }

  async retrieveCodes(type, options) {
    const {
      content: codes,
    } = await this.store.request(findAll(`${type}-code`));

    return this.filterCodesByOptions(type, codes, options);
  }
}
